import clsx from "clsx";
import { string } from "prop-types";

import classes from "./LoadingCard.module.scss";

const DURATION_HINT = "This wont take long...";

// Appearance only — positioning belongs to the caller, so the same card can be
// centred in the viewport by LoadingModal or inside a container by an overlay.
const LoadingCard = ({ className, message }) => (
  <div className={clsx(classes.card, className)} data-testid="loading-card">
    <div className={classes.icon} />
    <p className={classes.message}>{message}</p>
    <strong className={classes.hint}>{DURATION_HINT}</strong>
  </div>
);

LoadingCard.propTypes = {
  className: string,
  message: string,
};

export default LoadingCard;
